import {
  Box,
  Typography,
  Grid2 as Grid,
  TextField,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  IconButton,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import TableOverview from "./TableOverview";
import ScheduleContractorRonModal from "../../modals/ScheduleContractorRonModal";
import SigneeRegisterInfo from "../../popover/SigneeRegisterInfo";

const RegSigneeMainContentComponent = ({
  formik,
  guestUser,
  propertyDetails,
  setDocumentModal,
  ownerTypes,
  setOwnerTypes,
  fullOwners,
  copyOwners,
  setCopyOwners,
  ownerships,
  isFieldsDisabled,
  setSignerType,
  markSignerNameEdited,
  mobileSize,
  tabletSize,
  largeTabletSize,
  titleInfo,
  typeInfo,
  setTitleInfo,
  setTypeInfo,
  infoText,
  setInfoText,
  titleIsFadingOut,
  isFadingOut,
  signerTitles,
  authorityTypes,
  open,
  setOpen,
  selectedRow,
  userTimezone,
  usStates,
}) => {
  return (
    <Box
      sx={{
        flexGrow: 2,
        overflowY: "auto",
        paddingRight: "calc(100% - 100vw)",
        py: 2,
        bgcolor: "background.paper",
        maxWidth: "90rem",
        width: "100%",
        ml: "auto",
        mr: "auto",
        mb: "70px",
      }}
    >
      {!guestUser?.registerData?.cst_packageID && (
        <TableOverview
          propertyDetails={propertyDetails}
          setDocumentModal={setDocumentModal}
          ownerTypes={ownerTypes}
          setOwnerTypes={setOwnerTypes}
          formik={formik}
          fullOwners={fullOwners}
          copyOwners={copyOwners}
          setCopyOwners={setCopyOwners}
          ownerships={ownerships}
          isFieldsDisabled={isFieldsDisabled}
          setSignerType={setSignerType}
          mobileSize={mobileSize}
          tabletSize={tabletSize}
          largeTabletSize={largeTabletSize}
        />
      )}

      <Box
        sx={{
          borderBottom: largeTabletSize ? "none" : "3px solid #f3f3f3",
          pb: 1,
          mb: largeTabletSize ? 0 : 2,
          mt: 2,
          mx: mobileSize ? 0.5 : 2,
        }}
      >
        <Typography variant={mobileSize ? "h5" : "h4"} align="center">
          Property Owner or Authorized Agent
        </Typography>
        <Typography
          sx={{
            mt: largeTabletSize ? 0.2 : 1,
          }}
          variant={mobileSize ? "body2" : "body1"}
          align="center"
        >
          Please Enter the Information of the Person Signing the Document
        </Typography>
      </Box>
      <Box sx={{ px: mobileSize ? 0.5 : 2, pb: 4 }}>
        <Grid container spacing={largeTabletSize ? 1 : 2}>
          <Grid size={{ xs: 12, lg: 4 }}>
            <TextField
              disabled={isFieldsDisabled()}
              error={Boolean(formik.touched.name && formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
              name="name"
              label="Signer Name"
              variant="filled"
              fullWidth
              onBlur={formik.handleBlur}
              value={formik.values.name}
              onChange={(e) => {
                formik.handleChange(e);
                markSignerNameEdited?.();
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, lg: 4 }} sx={{ position: "relative" }}>
            <FormControl fullWidth variant="filled">
              <InputLabel>Signer Title</InputLabel>
              <Select
                error={Boolean(
                  formik.touched.signatoryTitle && formik.errors.signatoryTitle,
                )}
                disabled={isFieldsDisabled()}
                value={formik.values.signatoryTitle}
                name="signatoryTitle"
                variant="filled"
                fullWidth
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  if (e.target.value === "None") {
                    formik.setFieldValue("signatoryTitle", "");
                  } else {
                    formik.handleChange(e);
                  }
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      marginTop: "1.5px",
                      maxHeight: 150, // Set the desired max height for the dropdown menu
                      width: "auto",
                    },
                  },
                }}
                sx={{
                  maxWidth: "100%", // Set the desired max-width for the input element
                  "& .MuiTypography-body2": {
                    whiteSpace: "wrap", // Prevent text from wrapping or shrinking
                  },
                }}
              >
                {signerTitles?.map(function (item, i) {
                  return (
                    <MenuItem key={i} value={item}>
                      {item}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <FormHelperText sx={{ color: "red" }}>
              {formik.touched.signatoryTitle && formik.errors.signatoryTitle}
            </FormHelperText>
            {titleInfo && (
              <SigneeRegisterInfo
                infoText={infoText}
                isFadingOut={titleIsFadingOut}
                top={mobileSize ? -180 : largeTabletSize ? -80 : -145}
              />
            )}
            <Box sx={{ position: "absolute", right: 30, top: 10 }}>
              <IconButton
                onClick={() => {
                  if (typeInfo) {
                    setTypeInfo(false);
                  }
                  if (titleInfo) {
                    setTitleInfo(false);
                  }
                  if (!titleInfo) {
                    setTitleInfo(true);
                    setInfoText(
                      "Please provide the job title of the person in the organization that owns the property, and who will sign the documents (e.g., Owner, President, Manager). If signing as an individual's agent specify your authority (like Agent or Trustee). Leave blank if signing for yourself.",
                    );
                  }
                }}
                sx={{ pr: 0 }}
              >
                <HelpOutlineIcon color="success" />
              </IconButton>
            </Box>
          </Grid>

          <Grid size={{ xs: 12, lg: 4 }} sx={{ position: "relative" }}>
            <FormControl fullWidth variant="filled">
              <InputLabel>Type of authority</InputLabel>
              <Select
                error={Boolean(
                  formik.touched.authority && formik.errors.authority,
                )}
                disabled={isFieldsDisabled()}
                value={formik.values.authority}
                name="authority"
                variant="filled"
                fullWidth
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  if (e.target.value === "None") {
                    formik.setFieldValue("authority", "");
                  } else {
                    formik.handleChange(e);
                  }
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      marginTop: "1.5px",
                      maxHeight: 150, // Set the desired max height for the dropdown menu
                      width: "auto",
                    },
                  },
                }}
                sx={{
                  maxWidth: "100%", // Set the desired max-width for the input element
                  "& .MuiTypography-body2": {
                    whiteSpace: "wrap", // Prevent text from wrapping or shrinking
                  },
                }}
              >
                {authorityTypes?.map(function (item, i) {
                  return (
                    <MenuItem key={i} value={item}>
                      {item}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <FormHelperText sx={{ color: "red" }}>
              {formik.touched.authority && formik.errors.authority}
            </FormHelperText>
            {typeInfo && (
              <SigneeRegisterInfo
                infoText={infoText}
                isFadingOut={isFadingOut}
                top={mobileSize ? -130 : largeTabletSize ? -80 : -125}
              />
            )}
            <Box sx={{ position: "absolute", right: 30, top: 10 }}>
              <IconButton
                onClick={() => {
                  if (titleInfo) {
                    setTitleInfo(false);
                  }
                  if (typeInfo) {
                    setTypeInfo(false);
                  }
                  if (!typeInfo) {
                    setTypeInfo(true);
                    setInfoText(
                      "This is the authority under which you are signing this document. It could be as an Agent, trustee, or anything else on behalf of the Owner. Leave blank if signing for yourself.",
                    );
                  }
                }}
                sx={{ pr: 0 }}
              >
                <HelpOutlineIcon color="success" />
              </IconButton>
            </Box>
          </Grid>
          {!guestUser?.registerData?.cst_packageID && (
            <Grid size={{ xs: 12, lg: 3 }}>
              <TextField
                disabled={isFieldsDisabled()}
                error={Boolean(formik.touched.address && formik.errors.address)}
                helperText={formik.touched.address && formik.errors.address}
                name="address"
                label="Address"
                variant="filled"
                fullWidth
                onBlur={formik.handleBlur}
                value={formik.values.address}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              />
            </Grid>
          )}

          {!guestUser?.registerData?.cst_packageID && (
            <Grid size={{ xs: 12, lg: 3 }}>
              <TextField
                disabled={isFieldsDisabled()}
                error={Boolean(formik.touched.city && formik.errors.city)}
                helperText={formik.touched.city && formik.errors.city}
                name="city"
                label="City"
                variant="filled"
                fullWidth
                onBlur={formik.handleBlur}
                value={formik.values.city}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              />
            </Grid>
          )}

          {!guestUser?.registerData?.cst_packageID && (
            <Grid size={{ xs: 12, lg: 3 }}>
              <FormControl
                variant="filled"
                fullWidth
                error={Boolean(formik.touched.state && formik.errors.state)}
              >
                <InputLabel
                  sx={{
                    color:
                      formik.touched.state && formik.errors.state
                        ? "#f04438"
                        : "auto",
                    maxWidth: "90%", // Limit the label's width
                    whiteSpace: "nowrap", // Prevent label from wrapping
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  id="fullOwnerSelect-label"
                >
                  State
                </InputLabel>
                <Select
                  disabled={isFieldsDisabled()}
                  error={Boolean(formik.touched.state && formik.errors.state)}
                  fullWidth
                  name="state"
                  value={formik.values.state}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        marginTop: "1.5px",
                        maxHeight: 150, // Set the desired max height for the dropdown menu
                        width: "auto",
                        maxWidth: "100%",
                      },
                    },
                  }}
                  sx={{
                    maxWidth: "100%", // Set the desired max-width for the input element
                    "& .MuiTypography-body2": {
                      whiteSpace: "wrap", // Prevent text from wrapping or shrinking
                    },
                  }}
                >
                  {usStates.map((item, index) => (
                    <MenuItem key={`${item.name}-${index}`} value={item.name}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText sx={{ color: "#f04438" }}>
                  {formik.touched.state && formik.errors.state}
                </FormHelperText>
              </FormControl>
            </Grid>
          )}

          {!guestUser?.registerData?.cst_packageID && (
            <Grid size={{ xs: 12, lg: 3 }}>
              <TextField
                disabled={isFieldsDisabled()}
                error={Boolean(formik.touched.zipCode && formik.errors.zipCode)}
                helperText={formik.touched.zipCode && formik.errors.zipCode}
                name="zipCode"
                label="Zip Code"
                variant="filled"
                fullWidth
                onBlur={formik.handleBlur}
                value={formik.values.zipCode}
                onChange={(e) => {
                  if (e.target.value.length > 5) {
                    return;
                  } else {
                    formik.handleChange(e);
                  }
                }}
              />
            </Grid>
          )}
        </Grid>
      </Box>
      {/* Only mount the modal when it needs to be open - prevents useEffect triggers from parent re-renders */}
      {open && (
        <Box>
          <ScheduleContractorRonModal
            open={open}
            setOpen={setOpen}
            selectedRow={selectedRow}
            setRonStarted={false}
            setSnackOpen={null}
            ownerData={formik?.values}
            ownerZone={userTimezone}
          />
        </Box>
      )}
    </Box>
  );
};

export default RegSigneeMainContentComponent;
